import { configureStore } from '@reduxjs/toolkit'
import userSlice from './userSlice'
import categoriesReducer from './category/getAllCategorySlice'
import subCategorySlice from './subcategories/getAllSubcategorySlice'
import level3Slice from './level3/getAllLevel3slice'
import getatributesSlice  from './atributes/getAllAtributes'
import getAllManufacturerSlice from './manufacturer/getAllManufacturerSlice'
import  getCategoryHeirarchySlice from './getCategoryHeirarchy'
import customerSlice from './customer/customerSlice'
import adminSlice from './admin/adminSlice'
import vendorSlice from './vendor/vendorSlice'
import productSlice from './productSlice'
import appearencesSlice from './appearanceSlice'
import sampleRequestSlice from './sampleRequestSlice'
import orderSlice from './orderSlice'
import scheduleSlice from './schedulecartslice'
import bomenqSlice from './bomSlice'
import bomOrderSlice from './bomOrderSlice'
import wizardenqSlice from './wizardSlice'
import wizardOrderSlice from './wizardOrderSlice'
import excessSlice from './excessSlice'
import excessOrderSlice from './excessOrderSlice'
import notificationSlice from './notification/notification'
import scheduleOrderSlice from "./scheduledOrders"
import vendorExcessSlice from './vendorExcessSlice'
import vendorOrderSlice from './vendor/vendororderSlice'
import dashboardSlice from './dashboardSlice'

export const store = configureStore({
    reducer: {
        user: userSlice,
        categories:categoriesReducer,
        subcategory:subCategorySlice,
        level3:level3Slice,
        atributes:getatributesSlice,
        manufacturer:getAllManufacturerSlice,
        customer:customerSlice,
        vendor:vendorSlice,
        categoryHeirarchy:getCategoryHeirarchySlice,
        admin:adminSlice,
        products:productSlice,
        appearances:appearencesSlice,
        samplerequest:sampleRequestSlice,
        orders:orderSlice,
        schedule:scheduleSlice,
        scheduleorder: scheduleOrderSlice,
        bom:bomenqSlice,
        bomOrder:bomOrderSlice,
        wizardOrder:wizardOrderSlice,
        wizard:wizardenqSlice,
        excess:excessSlice,
        excessOrder:excessOrderSlice,
        notification:notificationSlice,
        vendorexcess:vendorExcessSlice,
        vendorOrder:vendorOrderSlice,
        dashboard:dashboardSlice
    },

})